import { useEffect } from 'react';
import { IsJsonString } from 'helpers';
import ColumnMonitoringModel, { enumColumn } from 'models/column-monitoring.model';
import getUser from 'redux/selector/getUser';
import { isArray } from 'lodash';

const checkFieldAvailable = ({ data = [], field = 'value', value = '' }) => {
  return !!data.find((el) => el?.[field] === value);
};

const defaultColumns = new ColumnMonitoringModel().columns;

//* Like middleware + handle layout: Monitoring + Contact
const useColumnsHandler = () => {
  const userInfo = getUser();
  const campaignMonitoringLayout = userInfo?.settings?.campaignMonitoringLayout || '';

  //! Fix bug for some reason, one column is removed
  useEffect(() => {
    if (!userInfo.isLogged) {
      return;
    }

    if (campaignMonitoringLayout && IsJsonString(campaignMonitoringLayout)) {
      const parsedCampaignMonitoringLayout = JSON.parse(campaignMonitoringLayout);

      if (isArray(parsedCampaignMonitoringLayout)) {
        const layouts = {
          v1: parsedCampaignMonitoringLayout,
          v2: [],
        };

        ColumnMonitoringModel.saveLayout(layouts);
      } else {
        const handleColumnV1 = () => {
          //* Fix bug TA-10624 - https://textback.atlassian.net/browse/TA-10642
          const fieldNeedCheck = [
            enumColumn.progress,
            enumColumn.timeRemaining,
            enumColumn.speed,
            enumColumn.profit,
            enumColumn.activeCallCount,
            enumColumn.ROI,
            enumColumn.revenuePerMilMinute,
            enumColumn.revenuePerMilMessage,
            enumColumn.revenuePerCalls,
            enumColumn.callRate,
            enumColumn.username,
          ];

          let needUpdate = false;
          fieldNeedCheck.forEach((field) => {
            const isFieldNotFound = !checkFieldAvailable({
              data: parsedCampaignMonitoringLayout,
              value: field,
            });

            if (isFieldNotFound) {
              needUpdate = true;

              const temp = {
                column: defaultColumns?.find((el) => el.value === field)?.column,
                value: field,
                isChecked: true,
                isSortable: true,
                width: '200px',
              };

              parsedCampaignMonitoringLayout.push(temp);
            }
          });

          const costGrouped = parsedCampaignMonitoringLayout.find(
            (el) => el.value === enumColumn.cost,
          );
          const fieldInCostNeedCheck = [enumColumn.amdCost];

          fieldInCostNeedCheck.forEach((field) => {
            const isFieldNotFound = !costGrouped?.subColumn?.find((col) => col.value === field);

            if (isFieldNotFound) {
              needUpdate = true;
              const defaultCostGrouped = defaultColumns?.find((el) => el.value === enumColumn.cost);

              const temp = {
                column: defaultCostGrouped?.subColumn?.find((el) => el.value === field)?.column,
                value: field,
                isChecked: true,
                isChild: true,
                isSortable: true,
                width: '100px',
              };

              costGrouped.subColumn.push(temp);
            }
          });

          //* Add callbackCount to statistic
          const statistic = parsedCampaignMonitoringLayout.find(
            (el) => el.value === enumColumn.statistic,
          );
          const fieldInStatisticsNeedCheck = [
            enumColumn.callbackCount,
            enumColumn.listenCounter,
            enumColumn.callDurationInMinute,
            enumColumn.callDurationInSecond,
            enumColumn.ivrClickRate,
            enumColumn.ivrOptoutRate,
            enumColumn.amd,
          ];

          fieldInStatisticsNeedCheck.forEach((field) => {
            const isFieldNotFound = !statistic?.subColumn?.find((col) => col.value === field);

            if (isFieldNotFound) {
              needUpdate = true;
              const defaultStatistic = defaultColumns?.find(
                (el) => el.value === enumColumn.statistic,
              );

              const temp = {
                column: defaultStatistic?.subColumn?.find((el) => el.value === field)?.column,
                value: field,
                isChecked: true,
                isChild: true,
                isSortable: true,
                width: '140px',
              };

              statistic.subColumn.push(temp);
            }
          });

          //* Disabled statistic sort -> Server is no longer support sort by stats
          if (statistic?.subColumn?.some((el) => el?.isSortable)) {
            needUpdate = true;
            statistic?.subColumn?.forEach((el) => {
              el.isSortable = false;
            });
          }

          if (needUpdate) {
            ColumnMonitoringModel.saveLayout(parsedCampaignMonitoringLayout);
          }
        };
      }
    }
  }, [userInfo.isLogged, campaignMonitoringLayout]);
};

export default useColumnsHandler;
